import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, CheckCircle2 } from 'lucide-react';
const results = [{
  day: 'Día 1-2',
  text: <>
        Vas a entender <strong data-id="element-278">por qué reaccionás</strong> como reaccionás y qué
        busca tu ex con cada mensaje.
      </>
}, {
  day: 'Día 3-4',
  text: <>
        Vas a tener un sistema claro para{' '}
        <strong data-id="element-279">clasificar cada mensaje</strong> y saber cuáles merecen
        respuesta.
      </>
}, {
  day: 'Día 5-6',
  text: <>
        Vas a responder con <strong data-id="element-280">fórmulas probadas</strong> que cortan el
        conflicto sin escalar.
      </>
}, {
  day: 'Día 7',
  text: <>
        Vas a notar que el tono de las conversaciones empieza a cambiar.{' '}
        <strong data-id="element-281">Menos drama, más logística.</strong>
      </>
}];
export function ResultsSection() {
  return <section className="bg-[#17304F] py-24 px-6" data-id="element-282">
      <div className="max-w-3xl mx-auto" data-id="element-283">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-284">
          <div className="inline-flex items-center justify-center bg-green-100 text-green-800 p-3 rounded-full mb-6" data-id="element-285">
            <Calendar size={28} data-id="element-286" />
          </div>
          <h2 className="font-playfair text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-287">
            Qué vas a lograr en los primeros 7 días
          </h2>
          <p className="text-lg text-slate-300 max-w-xl mx-auto" data-id="element-288">
            Resultados <strong data-id="element-289">concretos y realistas</strong> aplicando los
            protocolos del manual.
          </p>
        </motion.div>

        <div className="space-y-6 mb-12" data-id="element-290">
          {results.map((result, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-6 rounded-xl shadow-sm border border-slate-200 flex flex-col sm:flex-row items-start sm:items-center gap-4" data-id="element-291">
              <div className="bg-navy text-white font-bold px-4 py-2 rounded-lg whitespace-nowrap" data-id="element-292">
                {result.day}
              </div>
              <p className="text-slate-700 text-lg font-medium" data-id="element-293">
                {result.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}